import { Component, OnInit } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { forkJoin } from 'rxjs';
import { TitleComponent } from 'src/app/shared/components/title/title.component';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';
import { Protocol, RuleGroup, OperativaStatsResponse } from 'src/app/shared/interfaces/holidays.interface';
import { ProtocolCardComponent } from 'src/app/shared/components/vacations/protocol-card/protocol-card.component';
import { RuleGroupCardComponent } from 'src/app/shared/components/vacations/rule-group-card/rule-group-card.component';
import { RulesListComponent } from 'src/app/shared/components/vacations/rules-list/rules-list.component';

@Component({
  selector: 'app-protocols',
  imports: [
    CommonModule,
    TitleComponent,
    RouterLink,
    MatButtonModule,
    MatTabsModule,
    LoaderComponent,
    ProtocolCardComponent,
    RuleGroupCardComponent,
    RulesListComponent,
  ],
  templateUrl: './protocols.component.html',
  styleUrls: ['./protocols.component.css', '../../../shared/styles/layout.css'],
})
export class ProtocolsComponent implements OnInit {
  protocols: Protocol[] = [];
  ruleGroups: RuleGroup[] = [];
  rules: any[] = [];
  operativaStats: OperativaStatsResponse | null = null;
  selectedTabIndex: number = 0;

  constructor(
    private loaderService: LoaderService,
    private holidaysService: HolidaysService,
    private route: ActivatedRoute
  ) {}

  get isLoading() {
    return this.loaderService.getLoader();
  }

  ngOnInit() {
    // Read query parameter for tab selection
    this.route.queryParams.subscribe(params => {
      const tab = params['tab'];
      if (tab === 'grupos') {
        this.selectedTabIndex = 1;
      } else if (tab === 'reglas') {
        this.selectedTabIndex = 2;
      } else {
        this.selectedTabIndex = 0; // defaults to 'protocolos'
      }
    });

    this.loadData();
  }

  loadData(): void {
    this.loaderService.showLoader();
    forkJoin({
      protocols: this.holidaysService.getProtocols(false),
      ruleGroups: this.holidaysService.getRuleGroups(),
      rules: this.holidaysService.getRules(),
      operativaStats: this.holidaysService.getProtocolOperativaStats(),
    }).subscribe({
      next: ({ protocols, ruleGroups, rules, operativaStats }) => {
        // Filter to show only enabled and not deleted items
        this.protocols = protocols.filter((p) => p.enabled && !p.is_deleted);
        this.ruleGroups = ruleGroups.filter((rg) => !rg.is_deleted);
        this.rules = rules.filter((r) => !r.is_deleted);
        this.operativaStats = operativaStats;
        this.loaderService.hideLoader();
      },
      error: (error) => {
        console.error('Error loading data:', error);
        this.loaderService.hideLoader();
      },
    });
  }

  getRuleGroupCountForProtocol(protocolId: number): number {
    return this.ruleGroups.filter((rg) => rg.protocol === protocolId).length;
  }

  getOperativaCountForProtocol(protocolId: number): number {
    if (!this.operativaStats) return 0;
    const protocolStats = this.operativaStats.protocols.find(
      (p) => p.id === protocolId
    );
    return protocolStats ? protocolStats.operativa_count : 0;
  }

  get totalOperativas(): number {
    return this.operativaStats?.total_operativas ?? 0;
  }

  onProtocolCopied(): void {
    this.loadData();
  }
}
